module.exports = __webpack_public_path__ + "i18n/fr.63d6ef7b4c265092675f902e55e63f5c.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/fr.json
// module id = 1307
// module chunks = 59